export class BaseEventBus {
  constructor() {
    this.bus = {};
    this.off = this.off.bind(this);
    this.listen = this.listen.bind(this);
    this.dispatch = this.dispatch.bind(this);
    this.once = this.once.bind(this);
    this.clear = this.clear.bind(this);
    this.resetBus = this.resetBus.bind(this);
  }

  off(key, handler) {
    const index = this.bus[key]?.indexOf(handler) ?? -1;
    this.bus[key]?.splice(index >>> 0, 1);
  }

  listen(event, handler) {
    if (this.bus[event] === undefined) this.bus[event] = [];
    this.bus[event].push(handler);
    return () => this.off(event, handler);
  }

  dispatch(event, payload) {
    if (this.bus[event] !== undefined) {
      this.bus[event].forEach(fn => fn(payload));
    }
  }

  once(key, handler) {
    const handleOnce = payload => {
      handler(payload);
      this.off(key, handleOnce);
    };
    this.listen(key, handleOnce);
  }

  clear(event) {
    if (this.bus[event]) this.bus[event] = [];
  }

  resetBus() {
    this.bus = {};
  }
}

export default function getEventBusInstance({ debug, logPrefix } = { debug: false, logPrefix: 'unknow' }) {
  const bus = {};
  const logger = console.log;
  const prefix = `[${logPrefix ?? 'unknown'}][EventBus]`;

  const off = (key, handler) => {
    const index = bus[key]?.indexOf(handler) ?? -1;
    bus[key]?.splice(index >>> 0, 1);
  };

  const listen = (event, handler) => {
    log('[New Susbscription]: ' + event);
    if (bus[event] === undefined) bus[event] = [];
    bus[event].push(handler);
    return () => off(event, handler);
  };

  const dispatch = (event, payload) => {
    log('[Dispatch]: ' + event, payload);
    log('Bus: ', bus);
    if (bus[event] !== undefined) bus[event].forEach(fn => fn(payload));
  };

  const once = (key, handler) => {
    const handleOnce = payload => {
      handler(payload);
      off(key, handleOnce);
    };
    listen(key, handleOnce);
  };

  const clear = event => {
    if (bus[event]) bus[event] = [];
  };

  const resetBus = () => {
    for (const event in bus) {
      if (bus.hasOwnProperty(event)) {
        delete bus[event];
      }
    }
  };

  const getAllListenersFromEvent = event => {
    return bus[event];
  };

  const log = (...args) => {
    if (debug) logger(prefix, ...args);
  };

  return { listen, dispatch, once, off, bus, clear, resetBus, getAllListenersFromEvent };
}
